import { GridColDef } from '@mui/x-data-grid';

import { CvViewExtraWidget, CvViewTableJobBoardWidget } from '../../../DerivedCharts/helper';
import { IPostgreCvViewAggrDTO, IPostgreCvViewDTO } from '../../jobs/types/postgreJobsDTO';
import { CvViewWidget } from '../../jobs/types/postgreJobsWidgetProp';

export const getCvViewTableData = (
  widgetName: CvViewWidget,
  widgetData: IPostgreCvViewAggrDTO
): [IPostgreCvViewDTO[], GridColDef[]] => {
  let columns: GridColDef[] = [];
  switch (widgetName) {
    case CvViewTableJobBoardWidget.TABLE_RECRUITER_CAREERBUILDEREDGE:
    case CvViewTableJobBoardWidget.TABLE_RECRUITER_CVLIBRARY:
    case CvViewTableJobBoardWidget.TABLE_RECRUITER_CWJOBS:
    case CvViewTableJobBoardWidget.TABLE_RECRUITER_DICE:
    case CvViewTableJobBoardWidget.TABLE_RECRUITER_JOBSERVE:
    case CvViewTableJobBoardWidget.TABLE_RECRUITER_JOBSITE:
    case CvViewTableJobBoardWidget.TABLE_RECRUITER_MONSTERUS_PS:
    case CvViewTableJobBoardWidget.TABLE_RECRUITER_MONSTEREU:
    case CvViewTableJobBoardWidget.TABLE_RECRUITER_CAREERBUILDER:
    case CvViewTableJobBoardWidget.TABLE_RECRUITER_MONSTERUS_CLASSIC:
    case CvViewTableJobBoardWidget.TABLE_RECRUITER_TECHFETCH:
    case CvViewExtraWidget.TABLE_RECRUITER:
      columns = [
        { field: 'recruiterName', headerName: 'Recruiter Name', minWidth: 160, flex: 2 },
        {
          field: 'count',
          headerName: `View Count (${widgetData.count ?? 0})`,
          minWidth: 150,
          flex: 1,
        },
      ];
      break;
    case CvViewExtraWidget.TABLE_SOURCE:
      columns = [
        { field: 'downloadSource', headerName: 'Download Source', minWidth: 170, flex: 2 },
        {
          field: 'count',
          headerName: `View Count(${widgetData.count ?? 0})`,
          minWidth: 150,
          flex: 1,
        },
      ];
      break;
    case CvViewExtraWidget.TABLE_JOB_BOARD:
      columns = [
        { field: 'jobBoard', headerName: 'Job Board Name', minWidth: 170, flex: 2 },
        {
          field: 'count',
          headerName: `View Count(${widgetData.count ?? 0})`,
          minWidth: 150,
          flex: 1,
        },
      ];
      break;
    default:
      throw new Error("Invalid 'CvUpload Table Widget' type");
  }

  widgetData.resultSet.forEach((record, index) => (record.id = index));

  return [widgetData.resultSet, columns];
};

export const defaultCvViewWidgetData: IPostgreCvViewAggrDTO = {
  count: 0,
  countByDate: {},
  resultSet: [],
};
